module.exports = __webpack_public_path__ + "static/media/referensiel.4299f696.svg";